module.exports = __webpack_public_path__ + "static/img/14.d4900b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/zh/14.png
// module id = GTG7
// module chunks = 0